import { Box, CircularProgress, Grid, Paper } from '@mui/material';
import { useState } from 'react';
import { Query } from '@features/redux/apis/utils';
import { useSystemConfigMutation, useSystemConfigQuery } from '@features/redux/apis/system';
import { ForceOffsetHeader } from './ForceOffsetHeader';
import { ForceEffects } from './ForceEffects';
import { ForceMaterials } from './ForceMaterials';
import { useAlert } from '@hooks/useAlert';
import { useSelector } from 'react-redux';
import type { RootState } from '@features/redux/store';

const DEFAULT_DRAFT = {};

const useSystemConfig = Query.withDraft(useSystemConfigQuery, DEFAULT_DRAFT);

export const ForceOffset = ({
    stationID,
    productId,
    serialNumber,
}: {
    stationID?: number | null;
    productId?: string | null;
    serialNumber: string | null | undefined;
}) => {
    const { role } = useSelector(({ auth }: RootState) => auth.Roles);

    const { setAlert } = useAlert();

    if (!serialNumber) return null;

    const completeDisable = productId === null || productId === undefined || !role.isAdmin;

    const [unlocked, setUnlocked] = useState(false);

    const { isLoading, draft } = useSystemConfig({ serialNumber });
    const [state, dispatch] = draft;

    const [mutate, { isLoading: mutationLoading }] = useSystemConfigMutation({
        fixedCacheKey: 'ForceOffsetMutation',
    });

    const onSave = async () => {
        try {
            const resp: any = await mutate({
                serialNumber,
                config: state!,
                stationID: stationID!,
            });

            if (resp?.error?.status) throw new Error(resp.status);
            setUnlocked(false);
        } catch (e) {
            setAlert('Failed to save configuration!', 'error');
        }
    };

    return (
        <Paper elevation={0} sx={{ width: '100%', padding: 1, border: '1px solid #e0e0e0' }}>
            <Box
                display={'flex'}
                flex={1}
                p={1}
                mt={'10px'}
                width={'98%'}
                flexDirection={'column'}
                justifyContent={'center'}>
                <ForceOffsetHeader
                    productId={productId!}
                    disabled={completeDisable || mutationLoading}
                    loading={mutationLoading}
                    unlocked={unlocked}
                    onSave={onSave}
                    unlock={setUnlocked}
                />
                {isLoading ? (
                    <CircularProgress size='3rem' />
                ) : (
                    <ForceMaterials productId={productId!} unlocked={unlocked} state={state} dispatch={dispatch} />
                )}

                <ForceEffects />
            </Box>
        </Paper>
    );
};
